<template>
	<el-dialog title="提示" :visible.sync="visible" :before-close="beforeClose" width="400px">
		<div class="pt-12 pl-12 yx-color-text-primary font-h4-regular">
			<p>请先设置【协作规则】后绑定协作申请</p>
			<p class="yx-color-primary mt-12 cursor-pointer" @click="goHelp">
				协作规则教程
				<i class="el-icon-arrow-right"></i>
			</p>
		</div>
		<div slot="footer" class="footer-dialog">
			<el-button type="primary" @click="confirm">我知道了</el-button>
		</div>
	</el-dialog>
</template>
<script>
export default {
	data() {
		return {
			visible: false,
			dataAuthorityRule: '',
		};
	},
	methods: {
		show(dataAuthorityRule) {
			this.dataAuthorityRule = dataAuthorityRule;
			this.visible = true;
		},
		async confirm() {
			this.beforeClose();
		},
		goHelp() {
			window.open('https://yangxuan.feishu.cn/docx/UcOmdZ2TOoKRrMxpcABceKqMnvb?from=from_copylink', '_blank');
		},
		beforeClose() {
			this.dataAuthorityRule = '';
			this.visible = false;
		},
	},
};
</script>
<style lang="less" scoped></style>
